import { render, staticRenderFns } from "./betCoin.vue?vue&type=template&id=8a984a3a&scoped=true&"
import script from "./betCoin.vue?vue&type=script&lang=js&"
export * from "./betCoin.vue?vue&type=script&lang=js&"
import style0 from "./betCoin.vue?vue&type=style&index=0&id=8a984a3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a984a3a",
  null
  
)

component.options.__file = "betCoin.vue"
export default component.exports